import {IAddress} from "../interfaces/address";
import {Address, IGeoJSONPayload} from "./address";

/**
 * serializable user address
 */
export class EmptyAddress extends Address implements IAddress {
  public firstname: string;
  public lastname: string;
  public street: string;
  public postalcode: string|number;
  public location?: string;
  public identifier: number;
  public floor;

  public political: string;
  public sublocality: string;

  constructor(payload : any){
    super(payload);

  }


  static fromGeolocation(payload: IGeoJSONPayload) {
   return new EmptyAddress(null);
  }
}




// WEBPACK FOOTER //
// ./src/app/classes/empty_address.ts